import { useState, useEffect, useCallback } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: '动漫索引', href: '#index' },
  { label: '关于我们', href: '#about' },
  { label: '热门话题', href: '#topics' },
  { label: '移动追番', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
            <i className="ri-clapperboard-line text-background-50 text-xl"></i>
          </span>
          <span className="text-xl font-heading text-foreground-950 whitespace-nowrap">
            樱花动漫
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors rounded-md cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="block py-3 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer border-b border-background-100 last:border-0"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}